<template>
  <component
    :is="tag"
    :class="recipe.class"
    ><slot
  /></component>
</template>

<script>
// Module scope (plain <script>) so defineProps' validator can reference it.
const VARIANTS = {
  'page-title': { tag: 'h1', class: 'text-3xl font-bold tracking-tight text-content' },
  'section-heading': { tag: 'h2', class: 'text-2xl font-bold tracking-tight text-content' },
  'card-title': { tag: 'h3', class: 'text-lg font-semibold text-content' },
  subsection: { tag: 'h4', class: 'text-lg font-semibold text-content' },
  body: { tag: 'p', class: 'text-base text-content' },
  'body-strong': { tag: 'p', class: 'text-base font-semibold text-content' },
  secondary: { tag: 'p', class: 'text-sm text-content-muted' },
  label: { tag: 'label', class: 'text-sm font-medium text-content' },
  eyebrow: { tag: 'p', class: 'text-xs font-semibold uppercase tracking-wide text-content-muted' },
  caption: { tag: 'p', class: 'text-xs text-content-muted' },
};
</script>

<script setup>
// Single source of truth for typography. One component, all recipes (the Material/Polaris pattern).
import { computed } from 'vue';

const props = defineProps({
  /**
   * Which typographic recipe to render: page-title · section-heading · card-title · subsection ·
   * body · body-strong · secondary · label · eyebrow · caption.
   */
  variant: {
    type: String,
    default: 'body',
    validator: (value) => Object.keys(VARIANTS).includes(value),
  },
  /** Override the default semantic element when needed (e.g. a card-title rendered as `<h2>`). */
  as: {
    type: String,
    default: null,
  },
});

const recipe = computed(() => VARIANTS[props.variant]);
const tag = computed(() => props.as || recipe.value.tag);
</script>
